import { Field, SelectField, ColorField, Card } from '@/admin/fields';
import { FONT_OPTIONS, DENSITY_OPTIONS } from '@/lib/theme';

export function ThemeTab({ content, update }) {
  const t = content.theme;
  return (
    <Card
      title="Theme"
      hint="Purple means Unique, dark green means Unity. Save the draft and use Preview to see changes before publishing."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <ColorField label="Purple (Unique)" value={t.purple} onChange={(v) => update('theme.purple', v)} testId="edit-theme-purple" />
        <ColorField label="Dark green (Unity)" value={t.green} onChange={(v) => update('theme.green', v)} testId="edit-theme-green" />
        <ColorField label="Background (off-white)" value={t.ground} onChange={(v) => update('theme.ground', v)} testId="edit-theme-ground" />
        <ColorField label="Ink (near-black)" value={t.ink} onChange={(v) => update('theme.ink', v)} testId="edit-theme-ink" />
      </div>
      <SelectField
        label="Display font (headlines & wordmark)"
        value={t.displayFont}
        onChange={(v) => update('theme.displayFont', v)}
        options={FONT_OPTIONS.map((f) => ({ value: f.id, label: f.label }))}
        testId="edit-theme-font"
      />
      <SelectField
        label="Section spacing"
        value={t.density}
        onChange={(v) => update('theme.density', v)}
        options={DENSITY_OPTIONS.map((d) => ({ value: d.id, label: d.label }))}
        testId="edit-theme-density"
      />
    </Card>
  );
}
